import { render, staticRenderFns } from "./Introductory.vue?vue&type=template&id=2555c63a&"
import script from "./Introductory.vue?vue&type=script&lang=js&"
export * from "./Introductory.vue?vue&type=script&lang=js&"
import style0 from "./Introductory.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports